import React, { useRef, useState } from 'react';
import { AppContext } from '../App';
import { getConfiguration } from '../data/utils/configuration';
import { iconSportCssClass } from '../data/utils/iconSportCssClass';
import { appConfig } from '../appConfig';
import { labels } from '../data/labels';
import { PrematchContext } from '../prematch/Prematch';
import SearchOverlay from '../prematch/search/SearchOverlay';
import { Link } from 'react-router-dom';
import NavDropdown from '../prematch/main-menu/NavDropdown';

function SearchNavbar(props) {
    const appContext = React.useContext(AppContext);
    const prematchContext = React.useContext(PrematchContext);
    const conf = getConfiguration();
    const [showSearch, setShowSearch] = useState(false);
    const [search, setSearch] = useState('');

    function handleChange(event) {
        setSearch(event.target.value);
    }

    function handleReset() {
        input.current.value = '';
        input.current.focus();
        setSearch('');
    }

    function toggleSearch() {
        setShowSearch(!showSearch);
        if (showSearch) {
            setSearch('');
        }
    }

    function toggleCheckTicket(){
        appContext.toggleCheckTicketPopup();
    }

    const input = useRef(null);
    const favoriteTournamentsSelected = prematchContext.section === 'favorite-tournaments' ? ' selected' : '';
    return (
        <nav className="nav-buttons-container nav-buttons-container--template2">
            <div className="top-menu-buttons-container justify-content-space-between">
                {showSearch ?
                    <div className="top-menu-buttons-container">
                        <div className="input-container">
                            <input ref={input} id="input-search-events" type="text" autoComplete="off" placeholder={labels['general.search']} spellCheck="false" onChange={handleChange} autoFocus />
                            <div className="arrow-container">
                                <i className="fa fa-backspace" onClick={handleReset}></i>
                            </div>
                            {search.length > 2 &&
                                <SearchOverlay search={search} toggleSearch={toggleSearch} />
                            }
                        </div>
                    </div>
                    :
                    <>
                        <Link className="search-navbar-link" to={appConfig.ROUTES.prematch['prematch']} >
                            <div className="nav-slider-item-container sport-img-slider" onClick={() => {prematchContext.openMenu()}}>
                                <div className="sport-img-container">
                                    <div className={`sport-img ${iconSportCssClass('All')}`}></div>
                                </div>
                                <div className="nav-slider-item">{labels['general.tutti']}</div>
                            </div>
                        </Link>
                        {Object.keys(prematchContext.favoriteTournaments).length > 0 &&
                            <div className={"nav-slider-item-container sport-img-slider" + favoriteTournamentsSelected} onClick={() => {prematchContext.openFavoriteTournaments()}}>
                                <div className="sport-img-container">
                                    <i className="fa fa-star"></i>
                                </div>
                                <div className="nav-slider-item">{labels['navbar_buttons.favorite_tournaments']}</div>
                            </div>
                        }
                        <div className="padding"></div>
                    </>
                }
            </div>
            <div id="sport-selector" className={`${showSearch ? 'd-none' : ''}`}></div>
            {!showSearch &&
                <NavDropdown />
            }
            <div className="topMenuElement search-button" onClick={toggleSearch}>
                <i className="fa fa-search"></i>
            </div>
            {conf.mst && conf.mst != 'NONE' && 
                <div className="topMenuElement check-ticket-button" onClick={toggleCheckTicket}>
                    <i className="fa fa-camera"></i>
                </div>
            }
           
       </nav>
    )

}


export default SearchNavbar;